// extracted by mini-css-extract-plugin
export default {"root":"ShowApprovalPage_root__OgjIi"};